import { render, staticRenderFns } from "./CustomStatus.vue?vue&type=template&id=2f0eec58"
import script from "./CustomStatus.vue?vue&type=script&lang=js"
export * from "./CustomStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports